import { getActivityDateRanges } from '../activityDaysToDates';
import { RaFilterPanelState, RiskScoreSearchRequest } from '../types';
import { getDefaultRiskScoreSearchRequest } from './getDefaultRiskScoreSearchRequest';

interface Props {
  now: Date;
  fpState: RaFilterPanelState;
  pageIndex: number;
}
export function toRiskScoreSearchRequest({
  now,
  fpState,
  pageIndex,
}: Props): RiskScoreSearchRequest {
  const request = getDefaultRiskScoreSearchRequest();
  const { startDate, endDate } = getActivityDateRanges(
    now,
    +fpState.activityRange
  );
  request.startDate = startDate;
  request.endDate = endDate;
  request.fraudPatternTypeCode = fpState.fraudType;
  request.pageNumber = pageIndex;
  return request;
}
